import { assistanceService } from '../../../services/Assistance'
import { IAssistanceCategoryObject, IAssistanceObject } from '../../../types'
import {
  ASSISTANCE_CATEGORY_CREATE_FAILURE,
  ASSISTANCE_CATEGORY_CREATE_REQUEST,
  ASSISTANCE_CATEGORY_CREATE_SUCCESS,
  ASSISTANCE_CATEGORY_LIST_FAILURE,
  ASSISTANCE_CATEGORY_LIST_REQUEST,
  ASSISTANCE_CATEGORY_LIST_SUCCESS,
  ASSISTANCE_CATEGORY_REMOVE_FAILURE,
  ASSISTANCE_CATEGORY_REMOVE_REQUEST,
  ASSISTANCE_CATEGORY_REMOVE_SUCCESS,
  ASSISTANCE_CREATE_FAILURE,
  ASSISTANCE_CREATE_REQUEST,
  ASSISTANCE_CREATE_SUCCESS,
  ASSISTANCE_UPDATE_FAILURE,
  ASSISTANCE_UPDATE_REQUEST,
  ASSISTANCE_UPDATE_SUCCESS,
  ASSISTANCE_LIST_FAILURE,
  ASSISTANCE_LIST_REQUEST,
  ASSISTANCE_LIST_SUCCESS,
  ASSISTANCE_REMOVE_FAILURE,
  ASSISTANCE_REMOVE_REQUEST,
  ASSISTANCE_REMOVE_SUCCESS,
  ASSISTANCE_SEARCH_FAILURE,
  ASSISTANCE_SEARCH_REQUEST,
  ASSISTANCE_SEARCH_SUCCESS
} from '../../constants'
import { IAssistanceCategoriesWithOptions } from '../../../types/assistance'

// Assistance List
export interface IAssistanceListRequest {
  type: ASSISTANCE_LIST_REQUEST
}

export interface IAssistanceListSuccess {
  type: ASSISTANCE_LIST_SUCCESS
  assistances: IAssistanceObject[]
}

export interface IAssistanceListFailure {
  error: string
  type: ASSISTANCE_LIST_FAILURE
}

// Assistance Create
export interface IAssistanceCreateRequest {
  type: ASSISTANCE_CREATE_REQUEST
  assistance: IAssistanceObject
}

export interface IAssistanceCreateSuccess {
  type: ASSISTANCE_CREATE_SUCCESS
  assistance: IAssistanceObject
}

export interface IAssistanceCreateFailure {
  error: string
  assistance: IAssistanceObject
  type: ASSISTANCE_CREATE_FAILURE
}

// Assistance Update
export interface IAssistanceUpdateRequest {
  type: ASSISTANCE_UPDATE_REQUEST
}

export interface IAssistanceUpdateSuccess {
  type: ASSISTANCE_UPDATE_SUCCESS
  assistance: IAssistanceObject
}

export interface IAssistanceUpdateFailure {
  error: string
  type: ASSISTANCE_UPDATE_FAILURE
}

// Assistance Remove
export interface IAssistanceRemoveRequest {
  type: ASSISTANCE_REMOVE_REQUEST
}

export interface IAssistanceRemoveSuccess {
  type: ASSISTANCE_REMOVE_SUCCESS
  assistance: IAssistanceObject
}

export interface IAssistanceRemoveFailure {
  error: string
  type: ASSISTANCE_REMOVE_FAILURE
}

// Assistance Category List
export interface IAssistanceCategoryListRequest {
  type: ASSISTANCE_CATEGORY_LIST_REQUEST
}

export interface IAssistanceCategoryListSuccess {
  type: ASSISTANCE_CATEGORY_LIST_SUCCESS
  assistances: IAssistanceCategoryObject[]
}

export interface IAssistanceCategoryListFailure {
  error: string
  type: ASSISTANCE_CATEGORY_LIST_FAILURE
}

// Assistance Category Create
export interface IAssistanceCategoryCreateRequest {
  type: ASSISTANCE_CATEGORY_CREATE_REQUEST
  category: IAssistanceCategoryObject
}

export interface IAssistanceCategoryCreateSuccess {
  type: ASSISTANCE_CATEGORY_CREATE_SUCCESS
  category: IAssistanceCategoryObject
}

export interface IAssistanceCategoryCreateFailure {
  category: IAssistanceCategoryObject
  error: string
  type: ASSISTANCE_CATEGORY_CREATE_FAILURE
}

// Assistance Category Remove
export interface IAssistanceCategoryRemoveRequest {
  type: ASSISTANCE_CATEGORY_REMOVE_REQUEST
  category: IAssistanceCategoryObject
}

export interface IAssistanceCategoryRemoveSuccess {
  type: ASSISTANCE_CATEGORY_REMOVE_SUCCESS
}

export interface IAssistanceCategoryRemoveFailure {
  category: IAssistanceCategoryObject
  error: string
  type: ASSISTANCE_CATEGORY_REMOVE_FAILURE
}

// Assistance Search
export interface IAssistanceSearchRequest {
  type: ASSISTANCE_SEARCH_REQUEST
  query: string
}

export interface IAssistanceSearchSuccess {
  type: ASSISTANCE_SEARCH_SUCCESS
  assistances: IAssistanceObject[]
}

export interface IAssistanceSearchFailure {
  error: string
  type: ASSISTANCE_SEARCH_FAILURE
}

export type IAssistanceAction =
  | IAssistanceListRequest
  | IAssistanceListSuccess
  | IAssistanceListFailure
  | IAssistanceRemoveRequest
  | IAssistanceRemoveSuccess
  | IAssistanceRemoveFailure
  | IAssistanceCreateRequest
  | IAssistanceCreateSuccess
  | IAssistanceCreateFailure
  | IAssistanceUpdateRequest
  | IAssistanceUpdateSuccess
  | IAssistanceUpdateFailure
export type IAssistanceCategoryAction =
  | IAssistanceCategoryListRequest
  | IAssistanceCategoryListSuccess
  | IAssistanceCategoryListFailure
  | IAssistanceCategoryCreateRequest
  | IAssistanceCategoryCreateSuccess
  | IAssistanceCategoryCreateFailure
  | IAssistanceCategoryRemoveRequest
  | IAssistanceCategoryRemoveSuccess
  | IAssistanceCategoryRemoveFailure
export type IAssistanceSearchAction = IAssistanceSearchRequest | IAssistanceSearchSuccess | IAssistanceSearchFailure
export type IErrorAction = IAssistanceListFailure

// LIST ACTIONS
export function assistanceListRequest(): IAssistanceListRequest {
  return {
    type: ASSISTANCE_LIST_REQUEST
  }
}

export function assistanceListSuccess(assistances: IAssistanceObject[]): IAssistanceListSuccess {
  return {
    assistances,
    type: ASSISTANCE_LIST_SUCCESS
  }
}

export function assistanceListFailure(error: string): IAssistanceListFailure {
  return {
    error,
    type: ASSISTANCE_LIST_FAILURE
  }
}

// CREATE ASSISTANCE
export function assistanceCreateRequest(assistance: IAssistanceObject): IAssistanceCreateRequest {
  return {
    type: ASSISTANCE_CREATE_REQUEST,
    assistance
  }
}

export function assistanceCreateSuccess(assistance: IAssistanceObject): IAssistanceCreateSuccess {
  return {
    assistance,
    type: ASSISTANCE_CREATE_SUCCESS
  }
}

export function assistanceCreateFailure(error: string, assistance: IAssistanceObject): IAssistanceCreateFailure {
  return {
    error,
    assistance,
    type: ASSISTANCE_CREATE_FAILURE
  }
}

export function assistanceUpdateRequest(): IAssistanceUpdateRequest {
  return {
    type: ASSISTANCE_UPDATE_REQUEST
  }
}

export function assistanceUpdateSuccess(assistance: IAssistanceObject): IAssistanceUpdateSuccess {
  return {
    assistance,
    type: ASSISTANCE_UPDATE_SUCCESS
  }
}

export function assistanceUpdateFailure(error: string): IAssistanceUpdateFailure {
  return {
    error,
    type: ASSISTANCE_UPDATE_FAILURE
  }
}

// REMOVE ACTIONS
export function assistanceRemoveRequest(): IAssistanceRemoveRequest {
  return {
    type: ASSISTANCE_REMOVE_REQUEST
  }
}

export function assistanceRemoveSuccess(assistance: IAssistanceObject): IAssistanceRemoveSuccess {
  return {
    assistance,
    type: ASSISTANCE_REMOVE_SUCCESS
  }
}

export function assistanceRemoveFailure(error: string): IAssistanceRemoveFailure {
  return {
    error,
    type: ASSISTANCE_REMOVE_FAILURE
  }
}

// LIST CATEGORY ACTIONS
export function assistanceCategoryListRequest(): IAssistanceCategoryListRequest {
  return {
    type: ASSISTANCE_CATEGORY_LIST_REQUEST
  }
}

export function assistanceCategoryListSuccess(
  assistances: IAssistanceCategoryObject[]
): IAssistanceCategoryListSuccess {
  return {
    assistances,
    type: ASSISTANCE_CATEGORY_LIST_SUCCESS
  }
}

export function assistanceCategoryListFailure(error: string): IAssistanceCategoryListFailure {
  return {
    error,
    type: ASSISTANCE_CATEGORY_LIST_FAILURE
  }
}

// CATEGORY CREATE ACTIONS
export function assistanceCategoryCreateRequest(category: IAssistanceCategoryObject): IAssistanceCategoryCreateRequest {
  return {
    type: ASSISTANCE_CATEGORY_CREATE_REQUEST,
    category
  }
}

export function assistanceCategoryCreateSuccess(category: IAssistanceCategoryObject): IAssistanceCategoryCreateSuccess {
  return {
    category,
    type: ASSISTANCE_CATEGORY_CREATE_SUCCESS
  }
}

export function assistanceCategoryCreateFailure(
  error: string,
  category: IAssistanceCategoryObject
): IAssistanceCategoryCreateFailure {
  return {
    category,
    error,
    type: ASSISTANCE_CATEGORY_CREATE_FAILURE
  }
}

// CATEGORY REMOVE ACTIONS
export function assistanceCategoryRemoveRequest(category: IAssistanceCategoryObject): IAssistanceCategoryRemoveRequest {
  return {
    category,
    type: ASSISTANCE_CATEGORY_REMOVE_REQUEST
  }
}

export function assistanceCategoryRemoveSuccess(): IAssistanceCategoryRemoveSuccess {
  return {
    type: ASSISTANCE_CATEGORY_REMOVE_SUCCESS
  }
}

export function assistanceCategoryRemoveFailure(
  error: string,
  category: IAssistanceCategoryObject
): IAssistanceCategoryRemoveFailure {
  return {
    category,
    error,
    type: ASSISTANCE_CATEGORY_REMOVE_FAILURE
  }
}

// SEARCH ASSISTANCE ACTIONS
export function assistanceSearchRequest(query: string): IAssistanceSearchRequest {
  return {
    query,
    type: ASSISTANCE_SEARCH_REQUEST
  }
}

export function assistanceSearchSuccess(assistances: IAssistanceObject[]): IAssistanceSearchSuccess {
  return {
    assistances,
    type: ASSISTANCE_SEARCH_SUCCESS
  }
}

export function assistanceSearchFailure(error: string): IAssistanceSearchFailure {
  return {
    error,
    type: ASSISTANCE_SEARCH_FAILURE
  }
}

// Create Assistance
export function createAssistance(assistance: IAssistanceObject): any {
  return (dispatch: any) => {
    dispatch(assistanceCreateRequest(assistance))
    return assistanceService.createAssistance(assistance).then(
      (newAssistance: IAssistanceObject) => {
        dispatch(assistanceCreateSuccess(newAssistance))
      },
      error => {
        dispatch(assistanceCreateFailure(error, assistance))
        setTimeout(() => {
          dispatch(assistanceCreateFailure('', assistance))
        }, 5000)
      }
    )
  }
}

export function updateAssistance(assistance: IAssistanceObject): any {
  return (dispatch: any) => {
    dispatch(assistanceUpdateRequest())
    return assistanceService.updateAssistance(assistance).then(
      (assistance: IAssistanceObject) => {
        dispatch(assistanceUpdateSuccess(assistance))
      },
      error => {
        dispatch(assistanceUpdateFailure(error))
        setTimeout(() => {
          dispatch(assistanceUpdateFailure(''))
        }, 5000)
      }
    )
  }
}

export function removeAssistance(assistance: IAssistanceObject): any {
  const copy = Object.assign({}, assistance)
  return (dispatch: any) => {
    dispatch(assistanceRemoveRequest())
    return assistanceService.removeAssistance(assistance).then(
      (assistance: IAssistanceObject) => {
        dispatch(assistanceRemoveSuccess(copy))
      },
      error => {
        dispatch(assistanceRemoveFailure(error))
        setTimeout(() => {
          dispatch(assistanceRemoveFailure(''))
        }, 5000)
      }
    )
  }
}

// Search assistance using a query
export function searchAssistances(query: string): any {
  return (dispatch: any) => {
    dispatch(assistanceSearchRequest(query))
    return assistanceService
      .searchAssistances(query)
      .then(
        (assistances: any) => dispatch(assistanceSearchSuccess(assistances)),
        (error: string) => dispatch(assistanceSearchFailure(error))
      )
  }
}

// Create Assistance Category
export function createCategory(category: IAssistanceCategoryObject): any {
  return (dispatch: any) => {
    dispatch(assistanceCategoryCreateRequest(category))
    return assistanceService.createCategory(category).then(
      (newCategory: IAssistanceCategoryObject) => {
        dispatch(assistanceCategoryCreateSuccess(newCategory))
      },
      error => {
        dispatch(assistanceCategoryCreateFailure(error, category))
        setTimeout(() => {
          dispatch(assistanceCategoryCreateFailure('', category))
        }, 5000)
      }
    )
  }
}

// Remove Assistance Category
export function removeCategory(category: IAssistanceCategoryObject): any {
  return (dispatch: any) => {
    dispatch(assistanceCategoryRemoveRequest(category))
    return assistanceService.removeCategory(category.id).then(
      () => {
        dispatch(assistanceCategoryRemoveSuccess())
      },
      error => {
        dispatch(assistanceCategoryRemoveFailure(error, category))
        setTimeout(() => {
          dispatch(assistanceCategoryRemoveFailure('', category))
        }, 5000)
      }
    )
  }
}

export const getAssistanceCategoriesWithOptions = () => (dispatch: any) => {
  dispatch(assistanceCategoryListRequest())
  dispatch(assistanceListRequest())
  return assistanceService.getAssistanceCategoriesWithOptions().then(
    ({ assistanceOptions, assistanceCategories }: IAssistanceCategoriesWithOptions) => {
      dispatch(assistanceCategoryListSuccess(assistanceCategories))
      dispatch(assistanceListSuccess(assistanceOptions))
    },
    error => {
      dispatch(assistanceCategoryListFailure(error))
      dispatch(assistanceListFailure(error))
    }
  )
}

export const getAssistances = () => (dispatch: any) => {
  dispatch(assistanceListRequest())
  return assistanceService.getAssistances().then(
    (assistance: any) => {
      dispatch(assistanceListSuccess(assistance))
    },
    error => {
      dispatch(assistanceListFailure(error))
    }
  )
}

export const getAssistanceCategories = () => (dispatch: any) => {
  dispatch(assistanceCategoryListRequest())
  return assistanceService.getAssistanceCategories().then(
    (assistanceCategory: any) => {
      dispatch(assistanceCategoryListSuccess(assistanceCategory))
    },
    error => {
      dispatch(assistanceCategoryListFailure(error))
    }
  )
}



// WEBPACK FOOTER //
// ./src/state/actions/assistance/index.ts